export default __webpack_public_path__ + "static/media/step-2.a18c3ac4.png";